import { BodyTextSettings } from './types';

export const bodyTextSettings: BodyTextSettings = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        body1: {
          fontSize: 2,
          lineHeight: 2,
        },
        body2: {
          fontSize: 1,
          lineHeight: 1,
        },
        body3: {
          fontSize: 0,
          lineHeight: 0,
        },
      },
    },
  },
};
